import React from "react";
import { Card, Rate, Button, Typography, Tooltip, Image } from "antd";
import {
    StarOutlined,
    CheckCircleOutlined,
    ExclamationCircleOutlined,
} from "@ant-design/icons";
import AmazonLogo from "../../assests/Images/amazon.png";
import WalmartLogo from "../../assests/Images/walmart.png";
import TargetLogo from "../../assests/Images/target.png";
import BestBuyLogo from "../../assests/Images/best_buy1.png";
import HomeDepotLogo from "../../assests/Images/homedepot1.png";
import KrogerLogo from "../../assests/Images/kroger.png";
import WayfairLogo from "../../assests/Images/wayfair1.png";


import "./product-card.css";
import { formatNumber } from "../../shared/utils";

const { Text } = Typography;

const storeMeta = {
    Amazon: { logo: AmazonLogo, color: "#FF9900" },
    Walmart: { logo: WalmartLogo, color: "#0071ce" },
    Target: { logo: TargetLogo, color: "#cc0000" },
    BestBuy: { logo: BestBuyLogo, color: "#cc0000" },
    Bestbuy: { logo: BestBuyLogo, color: "#cc0000" },
    Homedepot: { logo: HomeDepotLogo, color: "#cc0000" },
    HomeDepot: { logo: HomeDepotLogo, color: "#cc0000" },
    Kroger: { logo: KrogerLogo, color: "#cc0000" },
    Wayfair: { logo: WayfairLogo, color: "#cc0000" },
};

export default function BestValueProductCard({
    image,
    display_title,
    title,
    rating,
    reviews,
    price,
    unit_price,
    store,
    link,
    buttonColor,
    fontColor,
    unit,
    capacity_per_item,
    capacity_per_pack,
    is_large_size,
    items_per_pack,

    amazon_price,
    amazon_link,
    amazon_unit_price,

    walmart_price,
    walmart_link,
    walmart_unit_price,

    target_price,
    target_link,
    target_unit_price,
    row,
    key,
    store_keys,
    pros,
    cons,
}) {

    let storeOptions = store_keys ? Object.entries(store_keys || {}).map(([keyName, keyValue]) => {
        let base = keyName.replace("_key", "").toLowerCase();
        let name = base.charAt(0).toUpperCase() + base.slice(1);

        if (base === "home_depot"){
          base = "homedepot"
        }


        return {
          name,
          key: keyValue,
          price: row[`${base}_price`] ?? row.price,
          unitPrice: row[`${base}_unit_price`] || row.unit_price,
          link: row[`${base}_link`] || row[`link_${base}`] ||  row.link,
          unit: row[`${base}_unit`] || row.unit
        };
      })
      :
      [{name:store,
        key: key,
        price: price,
        unitPrice: unit_price,
        link: link,
        unit: unit

      }]
      ;

      // ✅ if more than 1 store → filter + sort
      if (storeOptions?.length > 1) {
        storeOptions = storeOptions
          .filter((s) => s.key && s.link) // only keep valid
          .sort((a, b) => (a.unitPrice || 999999) - (b.unitPrice || 999999));
      }

      // ✅ if only 1 store → don’t filter/sort, show as-is



    return (
        <Card
            hoverable
            className="product-card"
            style={{
                width: "100%",
                border: "1px solid #005cff",
                borderRadius: "0px 0px 8px 8px",
                display: "flex",
                flexDirection: "column",
                gap: 16,
            }}
        >
            <div style={{ display: "flex", flexDirection: "row", width: "100%" }} className="all-picks-product-card">
                    {/* Left: Image */}
                    <div
                      className="product-card-image-container-new"
                      style={{
                        maxWidth: 80,
                        marginTop:"10px",
                        alignContent:"center"
                      }}
                    >
                      <img
                        alt={title}
                        src={image}
                        className="product-card-image"
                        width={"70px"}

                      />
                    </div>

                    {/* Right: Content */}
                    <div
                      style={{
                        flexGrow: 1,
                        padding: "6px 10px",
                        display: "flex",
                        flexDirection: "column",
                        width: "82%",
                      }}
                    >
                      {/* Title */}
                      <Tooltip title={title} placement="bottom">
                        <Text strong className="product-card-title">
                          {display_title
                            ? display_title.length > 70
                              ? `${display_title.substring(0, 70)}...`
                              : display_title
                            : title.length > 70
                            ? `${title.substring(0, 70)}...`
                            : title}
                        </Text>
                      </Tooltip>

                      {/* {(is_large_size || items_per_pack > 1) && ( */}
                      {!(
                        capacity_per_item === 1 &&
                        unit === "count" &&
                        items_per_pack === 1
                        ) && (
                        <Text
                            type="secondary"
                            className="product-card-subtitle"
                            style={{ display: "block" }}
                        >
                            {capacity_per_item} {unit} - {items_per_pack} pack
                        </Text>
                        )}
                      {/* )} */}

                      {/* Rating */}
                      <div style={{marginTop:"3px"}}

                      >
                        {row?.weighted_rating && row?.weighted_rating > 0 ? (

                            <Text className="product-card-rating">{Math.floor(row.weighted_rating * 10) / 10}  ⭐ ({formatNumber(row?.total_reviews)})</Text>

                        ) :
                        rating ? (

                          <Text className="product-card-rating">{Math.floor(rating * 10) / 10}  ⭐ ({formatNumber(reviews)})</Text>

                      ) :(
                            <Text className="product-card-rating" style={{ fontSize: 12 }}>
                            {/* ⭐ No Rating Yet */}
                            </Text>

                        )}
                      </div>
                      {pros && (
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    marginBottom: "4px",
                                    marginTop: "4px",
                                }}
                            >
                                <CheckCircleOutlined style={{ color: "#52c41a" }} />
                                <Text>{pros}</Text>
                            </div>
                        )}

                        {cons && (
                            <div
                                style={{ display: "flex", alignItems: "center", gap: "6px" }}
                            >
                                <ExclamationCircleOutlined style={{ color: "#ff4d4f"  }} />
                                <Text>{cons}</Text>
                            </div>
                        )}


                      {/* Store prices */}
                      <div
                        style={{
                          // marginTop: "10px",
                          display: "flex",
                          flexDirection: "column",
                          gap: "5px",
                          width: "100%",
                          marginTop:"10px"
                        }}
                      >
                        {storeOptions.map((store) => (
                          <>
                          <div
                            key={store.name}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              width: "100%",
                            }}
                          >
                            {/* Left: logo + price */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                minWidth: 0,
                                marginRight:"10px"
                              }}
                            >
                              <Image
                                src={storeMeta?.[store?.name]?.logo || KrogerLogo}
                                alt={store.name}
                                preview={false}
                                width={16}

                              />

                              {/* Price */}
                              {store?.price && (
                                <Text
                                  strong
                                  style={{
                                    fontSize: "16px",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  ${Math.floor(store.price)}
                                  <sup>{String(store.price.toFixed(2)).split(".")[1] || "00"}</sup>
                                </Text>
                              )}


                              {!(
                                capacity_per_item === 1 &&
                                unit === "count" &&
                                items_per_pack === 1
                                ) &&
                                store.unitPrice &&
                                unit &&  (
                                                                <Text
                                  type="secondary"
                                  style={{
                                    fontSize: "12px",
                                    flexShrink: 1,
                                    marginTop:"3px",

                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  (${Number(store.unitPrice).toFixed(2)}/{store.unit})
                                </Text>
                              )}
                            </div>

                            {/* Right: Buy button */}
                            <Button
                              className="product-link-button-sub-category"
                              type="primary"
                              style={{
                                background: "#ffffff",
                                color:"#005cff",
                                border:"1px solid #005cff",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "6px",
                                marginLeft: "auto",
                                padding:"8x!important"
                              }}
                              href={store.link}
                              target="_blank"
                            >
                              <span>Buy on </span>
                              <img
                                src={storeMeta?.[store?.name]?.logo || KrogerLogo}
                                alt={store.name}
                                style={{ width: 12, height: 12 }}
                              />
                            </Button>
                          </div>

                        </>
                        ))}
                      </div>
                    </div>
                  </div>
        </Card>
    );
}